"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePlaceholder = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var getPlaceholderText = function (dropEnabled, activeDropzone) {
    if (!dropEnabled) {
        return "Click to browse images";
    }
    return activeDropzone ? "Release to drop image" : "Drag an image or click to browse";
};
var ImagePlaceholder = (0, mobx_react_1.observer)(function (_a) {
    var onPickImage = _a.onPickImage, onDismiss = _a.onDismiss, activeDropzone = _a.activeDropzone, dropEnabled = _a.dropEnabled;
    return (react_1.default.createElement("div", { contentEditable: false, className: (0, classnames_1.default)("side-by-side__image-placeholder", {
            "side-by-side__image-placeholder--active": activeDropzone,
        }), onClick: onPickImage },
        react_1.default.createElement("div", { className: "image-placeholder__actions" },
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: "image-placeholder__dismiss", onClick: function (event) {
                    event.stopPropagation();
                    onDismiss();
                }, icon: react_1.default.createElement(icons_1.Delete, null), size: kaleidoscope_1.ButtonSize.XSmall, tooltip: {
                    content: "Delete",
                    position: kaleidoscope_2.TooltipPosition.Bottom,
                } })),
        react_1.default.createElement("div", { className: "image-placeholder__cta" },
            react_1.default.createElement("div", { className: "space-stack-m" },
                react_1.default.createElement(icons_1.Image, { size: icons_1.IconSize.Large, className: "image-placeholder__cta-icon" })),
            react_1.default.createElement("div", { className: "image-placeholder__cta-text" }, getPlaceholderText(dropEnabled, activeDropzone)))));
});
exports.ImagePlaceholder = ImagePlaceholder;
